<div class="payment grow--min ie--use-100vh grey-25-bg">
  <fin-loader aria-live="polite" [waitingFor]="'payment.initializing'"></fin-loader>
</div>
<link rel="dns-prefetch" [href]="checkoutUrl | finSafe: 'resource'" />
